import React, { Component } from "react";
import IconCheckmarkImage from "../../icons/icon-checkmark.svg";
import { submitForm, emailRegX } from '../common/templates/form/submitForm';
import IconCharge from '../../icons/icon-charge.svg';

class MailBox extends Component {
    constructor(props) {
        super(props);
        this.textInput = null;
        this.referrer = null;
    
        this.state = {
          emailField: "",
          emailValidation: "",
          submitButtonState: "",
          isPopupVisible: false,
        };
      }
    
      clearFields = () => {
        this.setState({
          emailField: "",
          emailValidation: "",
          //submitButtonState: "",
        });
      };
    
      handleEmailField = (event) => {
        event.preventDefault();
        const { value } = event.target;
        const validation = emailRegX.test(value) ? 'success-field' : 'error-field';
        this.setState({
          emailField: value,
          emailValidation: validation
        });
      };

    onSubmit = async (event) => {
        event.preventDefault();
        if (this.state.emailValidation === 'success-field') {
            this.setState({
            submitButtonState: "inProgress"
            });
            const requestData = {
            method: "post",
            url: "https://rapidopsbackend.kinsta.cloud/wp-json/gf/v2/entries",
            data: {
                "form_id": "2",
                "1": this.state.emailField,
            },
            };
            const response = await submitForm(requestData);
            if (response.status === 201) {
            setTimeout(() => {
                this.setState({
                submitButtonState: "finished",
                });
            }, 1500);
            }
            setTimeout(() => {
            this.clearFields();
            }, 3000);
        }
        };

    render() {
    
  return (
    <div className="mailbox-wrapper section-gap">
        <div className="container">
            <div className="mailbox">
                <div className="row d-flex flex-wrap">
                    <div className="col mailboxInfo">
                    <h3>Receive articles like this in your mailbox</h3>
                    <p>Sign up to get weekly insights & inspiration in your inbox.</p>
                    </div>
                    <div className="col mailboxForm">

                    {/* email form */}
                    <form name="mailboxForm" onSubmit={this.onSubmit} className="fomt-style-fancy mailbox-form d-flex">
                        <div className="input-mailbox">
                        <input
                            //onBlur={() => this.setState({ emailValidation: '' })}
                            onFocus={e => {
                            const validation = emailRegX.test(e.target.value) ? 'success-field' : 'error-field';
                            this.setState({ emailValidation: validation });
                            }}
                            placeholder="Enter work email"
                            type="email"
                            name="email"
                            className={`form-input ${this.state.emailValidation}`}
                            id="work-email"
                            autoComplete="off"
                            onChange={this.handleEmailField} required value={this.state.emailField || ""} />
                        </div>
                        <div className="mailbox-action">
                        <button type="submit" className={`button right-arrow ${this.state.submitButtonState}`}>
                            <span className="submit">Subscribe</span>
                            <span className="loading">Subscribe</span>
                            <span className="check"> <IconCheckmarkImage /> </span>
                        </button>
                        </div>
                    </form>
                    {this.state.submitButtonState === 'finished' && <p className="reading-info">Thank you for subscribing! </p>}
                    <p className="reading-info"><IconCharge /><strong>2500 people</strong> are reading this blog every week</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}
}
export default MailBox;